import {
    getGenders,
    getGendersDontKnow,
    getRaces,
    getEthnicOrigins,
    getYesOrNo,
    getYesOrNoOrDontKnow,
    getEnglish,
    getCountries,
    getCountriesDontknow,
    getStates,
    getStatesDontKnow,
    getProvinces,
    getProvincesDontKnow,
    getEducations,
    getStudents,
    getDegrees,
    getGPAs,
    getGrades,
    getEmploymentStatus,
    getOrganizationLevels,
    getDirectReports,
    getOccupationalAreas,
    getOccupations,
    getOccupationsPV,
    getTeaching,
    getDiagnosed,
    getHispanic,
    getHispanicRater,
    getHispanicRatee,
    getAboriginal,
    getAboriginalRater,
    getAboriginalRatee,
    getRacesByCountry,
    getRacesByCountryRater,
    getRacesByCountryRatee,
    getEducationsByCountry,
    getEducationsByCountryWithoutNotApplicable,
    getAge,
    getSpecialServices,
    getChildcareSetting,
    getChildRelationship,
    getSchoolSetting,
    getSpokenLanguage,
    getAssessmentReader,
    getAssessmentDataEnterer,
    getSubRaces,
    getTeacherHowWellKnown,
    getTeacherHowLongKnown,
    getTeacherHowOftenInteracted
} from '../../services/lookup-service';

import { getDummyLookup } from '../../test-data';

export const REQUEST_START = "demographics:requestStart";
export const REQUEST_LOAD = "demographics:requestLoad";
export const REQUEST_ERROR = "demographics:requestError";
export const REQUEST_END = "demographics:requestEnd";

export const LOOKUP_GENDER = "gender";
export const LOOKUP_GENDER_DONTKNOW = "genderDontKnow";
export const LOOKUP_RACE = "race";
export const LOOKUP_SUB_RACE = 'subRace';
export const LOOKUP_RACE_COUNTRY = "raceCountry";
export const LOOKUP_RACE_COUNTRY_RATER = "raceCountryRater";
export const LOOKUP_RACE_COUNTRY_RATEE = "raceCountryRatee";
export const LOOKUP_ETHNIC_ORIGINS = "ethnicOrigins";
export const LOOKUP_YESORNO = "yesOrNo";
export const LOOKUP_YESORNODONTKNOW = "yesOrNoDontKnow";
export const LOOKUP_ENGLISH = "english";
export const LOOKUP_COUNTRY = "country";
export const LOOKUP_COUNTRY_DONTKNOW = "countryDontKnow";
export const LOOKUP_STATE = "state";
export const LOOKUP_STATE_DONTKNOW = "stateDontKnow";
export const LOOKUP_PROVINCE = "province";
export const LOOKUP_PROVINCE_DONTKNOW = "provinceDontKnow";
export const LOOKUP_EDUCATION = "education";
export const LOOKUP_EDUCATION_COUNTRY = "educationCountry";
export const LOOKUP_EDUCATION_COUNTRY_WITHOUT_NOT_APPLICABLE = "educationCountryWithoutNotApplicable";
export const LOOKUP_STUDENT = "student";
export const LOOKUP_DEGREES = "degreee";
export const LOOKUP_GPA = "gpa";
export const LOOKUP_GRADE = "grade";
export const LOOKUP_EMPLOYEMENTSTATUS = "employmentStatus";
export const LOOKUP_ORGANIZATIONLEVEL = "organizationalLevel";
export const LOOKUP_DIRECTREPORTS = "directReports";
export const LOOKUP_OCCUPATIONALAREA = "occupationalArea";
export const LOOKUP_OCCUPATION = "occupation";
export const LOOKUP_OCCUPATION_PV = "occupationPV"; 
export const LOOKUP_TEACHING = "teaching";
export const LOOKUP_TEACHER_HOW_WELL_KNOWN = "teacherHowWellKnown";
export const LOOKUP_TEACHER_HOW_LONG_KNOWN = "teacherHowLongKnown";
export const LOOKUP_TEACHER_HOW_OFTEN_INTERACTED = "teacherHowOftenInteracted";
export const LOOKUP_DIAGNOSED = "diagnosed";
export const LOOKUP_HISPANIC = "hispanic";
export const LOOKUP_HISPANIC_RATER = "hispanicRatee";
export const LOOKUP_HISPANIC_RATEE = "hispanicRater";
export const LOOKUP_ABORIGINAL = "aboriginal";
export const LOOKUP_ABORIGINAL_RATER = "aboriginalRater";
export const LOOKUP_ABORIGINAL_RATEE = "aboriginalRatee";
export const LOOKUP_AGE = "age";
export const LOOKUP_SPECIAL_SERVICES = "specialServices";
export const LOOKUP_CHILDCARE_SETTING = "childcareSetting";
export const LOOKUP_CHILD_RELATIONSHIP = "childRelationship";
export const LOOKUP_SCHOOL_SETTING = "schoolSetting";
export const LOOKUP_SPOKEN_LANGUAGE = "spokenLanguage";
export const LOOKUP_ASSESSMENT_READER = "assessmentReader";
export const LOOKUP_ASSESSMENT_DATA_ENTERER = "assessmentDataEnterer";

const requestStart = (name) => ({
    type: REQUEST_START,
    name
})

const requestLoad = (name, items) => ({
    type: REQUEST_LOAD,
    name,
    items
})

const requestError = (name, error) => ({
    type: REQUEST_ERROR,
    name,
    error
})

const requestEnd = (name) => ({
    type: REQUEST_END,
    name
})

const getDummyOptions = (name, params) => {
    return (dispatch, getState) => {
        dispatch(requestStart(name));
        dispatch(requestLoad(name, getDummyLookup(name, params)));
        dispatch(requestEnd(name));
    }

}

const getOptions = ({name, service, params, isCached = true}) => {
    //return getDummyOptions(name, params);
    const shouldFetch = (state) => {
        if (isCached && (state.lookup && state.lookup[name] && state.lookup[name].items && state.lookup[name].items.length > 0)) {
            return false;
        }
        return true;
    }

    return (dispatch, getState) => {
        if (shouldFetch(getState())) {
            dispatch(requestStart(name));

            return service(params ? params : {},
                (response) => {
                    dispatch(requestLoad(name, response.data));
                },
                (error) => {
                    dispatch(requestError(name, error.message));
                },
                () => {
                    dispatch(requestEnd(name));
                }
            )
        }
    }
}

export const getGenderOptions = () => getOptions({ name: LOOKUP_GENDER, service: getGenders });

export const getGenderDontKnowOptions = () => getOptions({ name: LOOKUP_GENDER_DONTKNOW, service: getGendersDontKnow });

export const getRaceOptions = () => getOptions({ name: LOOKUP_RACE, service: getRaces });

export const getSubRaceOptions = (race) => getOptions({ name: LOOKUP_SUB_RACE, service: getSubRaces, params: { raceId: race }, isCached: false })

export const getRaceCountryOptions = (country) => getOptions({ name: LOOKUP_RACE_COUNTRY, service: getRacesByCountry, params: { countryId: country }, isCached: false })

export const getRaceCountryRaterOptions = (country) => getOptions({ name: LOOKUP_RACE_COUNTRY_RATER, service: getRacesByCountryRater, params: { countryId: country }, isCached: false });

export const getRaceCountryRateeOptions = (country) => getOptions({ name: LOOKUP_RACE_COUNTRY_RATEE, service: getRacesByCountryRatee, params: { countryId: country }, isCached: false });

export const getEthnicOriginsOptions = () => getOptions({ name: LOOKUP_ETHNIC_ORIGINS, service: getEthnicOrigins });

export const getYesOrNoOptions = () => getOptions({ name: LOOKUP_YESORNO, service: getYesOrNo });

export const getYesOrNoOrDontKnowOptions = () => getOptions({ name: LOOKUP_YESORNODONTKNOW, service: getYesOrNoOrDontKnow });

export const getEnglishOptions = () => getOptions({ name: LOOKUP_ENGLISH, service: getEnglish });

export const getCountryOptions = () => getOptions({ name: LOOKUP_COUNTRY, service: getCountries });

export const getCountryDontKnowOptions = () => getOptions({ name: LOOKUP_COUNTRY_DONTKNOW, service: getCountriesDontknow });

export const getStateOptions = () => getOptions({ name: LOOKUP_STATE, service: getStates });

export const getStateDontKnowOptions = () => getOptions({ name: LOOKUP_STATE_DONTKNOW, service: getStatesDontKnow });

export const getProvinceOptions = () => getOptions({ name: LOOKUP_PROVINCE, service: getProvinces });

export const getProvinceDontKnowOptions = () => getOptions({ name: LOOKUP_PROVINCE_DONTKNOW, service: getProvincesDontKnow })

export const getEducationOptions = () => getOptions({ name: LOOKUP_EDUCATION, service: getEducations });

export const getEducationCountryOptions = (country) => getOptions({ name: LOOKUP_EDUCATION_COUNTRY, service: getEducationsByCountry, params: { countryId: country }, isCached: false })

export const getEducationCountryWithoutNotApplicableOptions = (country) => getOptions({ name: LOOKUP_EDUCATION_COUNTRY_WITHOUT_NOT_APPLICABLE, service: getEducationsByCountryWithoutNotApplicable, params: { countryId: country }, isCached: false })

export const getStudentOptions = () => getOptions({ name: LOOKUP_STUDENT, service: getStudents });

export const getDegreeOptions = () => getOptions({ name: LOOKUP_DEGREES, service: getDegrees });

export const getGPAOptions = () => getOptions({ name: LOOKUP_GPA, service: getGPAs });

export const getGradeOptions = () => getOptions({ name: LOOKUP_GRADE, service: getGrades });

export const getEmploymentStatusOptions = () => getOptions({ name: LOOKUP_EMPLOYEMENTSTATUS, service: getEmploymentStatus });

export const getOrganizationLevelOptions = () => getOptions({ name: LOOKUP_ORGANIZATIONLEVEL, service: getOrganizationLevels });

export const getDirectReportsOptions = () => getOptions({ name: LOOKUP_DIRECTREPORTS, service: getDirectReports });

export const getOccupationalAreaOptions = () => getOptions({ name: LOOKUP_OCCUPATIONALAREA, service: getOccupationalAreas });

export const getOccupationOptions = (area) => getOptions({ name: LOOKUP_OCCUPATION, service: getOccupations, params: { area : area }, isCached: false });

export const getOccupationPVOptions = () => getOptions({ name: LOOKUP_OCCUPATION_PV, service: getOccupationsPV });

export const getTeachingOptions = () => getOptions({ name: LOOKUP_TEACHING, service: getTeaching });

export const getTeacherHowWellKnownOptions = () => getOptions({ name: LOOKUP_TEACHER_HOW_WELL_KNOWN, service: getTeacherHowWellKnown });

export const getTeacherHowLongKnownOptions = () => getOptions({ name: LOOKUP_TEACHER_HOW_LONG_KNOWN, service: getTeacherHowLongKnown });

export const getTeacherHowOftenInteractedOptions = () => getOptions({ name: LOOKUP_TEACHER_HOW_OFTEN_INTERACTED, service: getTeacherHowOftenInteracted });

export const getDiagnosedOptions = (area) => getOptions({ name: LOOKUP_DIAGNOSED, service: getDiagnosed, params: { area : area }, isCached: false });

export const getHispanicOptions = () => getOptions({ name: LOOKUP_HISPANIC, service: getHispanic });

export const getHispanicRaterOptions = () => getOptions({ name: LOOKUP_HISPANIC_RATER, service: getHispanicRater });

export const getHispanicRateeOptions = () => getOptions({ name: LOOKUP_HISPANIC_RATEE, service: getHispanicRatee });

export const getAboriginalOptions = () => getOptions({ name: LOOKUP_ABORIGINAL, service: getAboriginal });

export const getAboriginalRaterOptions = () => getOptions({ name: LOOKUP_ABORIGINAL_RATER, service: getAboriginalRater });

export const getAboriginalRateeOptions = () => getOptions({ name: LOOKUP_ABORIGINAL_RATEE, service: getAboriginalRatee });

export const getAgeOptions = () => getOptions({ name: LOOKUP_AGE, service: getAge });

export const getSpecialServicesOptions = () => getOptions({ name: LOOKUP_SPECIAL_SERVICES, service: getSpecialServices });

export const getChildcareSettingOptions = () => getOptions({ name: LOOKUP_CHILDCARE_SETTING, service: getChildcareSetting });

export const getChildRelationshipOptions = () => getOptions({ name: LOOKUP_CHILD_RELATIONSHIP, service: getChildRelationship });

export const getSchoolSettingOptions = () => getOptions({ name: LOOKUP_SCHOOL_SETTING, service: getSchoolSetting });

export const getSpokenLanguageOptions = () => getOptions({ name: LOOKUP_SPOKEN_LANGUAGE, service: getSpokenLanguage });

export const getAssessmentReaderOptions = () => getOptions({ name: LOOKUP_ASSESSMENT_READER, service: getAssessmentReader });

export const getAssessmentDataEntererOptions = () => getOptions({ name: LOOKUP_ASSESSMENT_DATA_ENTERER, service: getAssessmentDataEnterer });

export const isFetchingLookups = (state, lookupNames = []) => {
    lookupNames.forEach((value, index) => {
        const isFetching = isFetchingLookup(state, value);

        if (isFetching) {
            return true;
        }
    })

    return false;
}

export const isFetchingLookup = (state, lookupName) => {
    if (state && state.lookup && state.lookup[lookupName] && state.lookup[lookupName]) {
        return state.lookup[lookupName].isFetching;
    }

    return false;
}

export const getLookups = (state, lookupNames = []) => {
    const lookups = {};

    lookupNames.forEach((value, index) => {
        const lookup = getLookup(state, value);
        lookups[value] = lookup;
    })

    return lookups;
}

export const getLookup = (state, lookupName) => {
    if (state && state.lookup && state.lookup[lookupName] && state.lookup[lookupName].items) {
        return state.lookup[lookupName].items;
    } else {
        return [];
    }
}

export const getLookupErrors = (state, lookupNames = []) => {
    const errors = [];

    lookupNames.forEach((value, index) => {
        const error = getLookupError(state, value);

        if (error) {
            errors.push(error);
        }
    })

    return errors;
}

export const getLookupError = (state, lookupName) => {
    if (state && state.lookup && state.lookup[lookupName] && state.lookup[lookupName].hasError) {
        return state.lookup[lookupName].error;
    } else {
        return '';
    }
}
